import React from "react";
import { Video } from "lucide-react";

interface VideoTabsProps {
  /** Which tab is currently active */
  activeTab: "face" | "body";
  /** Callback when a tab is clicked */
  onTabChange: (tab: "face" | "body") => void;
}

/**
 * Simple tab component with two "video" tabs: Face and Body.
 * No content rendering—just the UI toggle.
 */
export function VideoTabs({ activeTab, onTabChange }: VideoTabsProps) {
  return (
    <div className="tw-p-4 tw-rounded-md">
      {/* Tab container */}
      <div className="tw-inline-flex tw-p-1 tw-rounded-lg tw-bg-gray-100">
        {/* Face tab */}
        <button
          onClick={() => onTabChange("face")}
          className={`
            tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-rounded-md
            ${
              activeTab === "face"
                ? "tw-bg-white tw-text-gray-900"
                : "tw-text-gray-500 hover:tw-text-gray-700"
            }
          `}
        >
          <Video className="tw-w-4 tw-h-4" />
          Face
        </button>

        {/* Body tab */}
        <button
          onClick={() => onTabChange("body")}
          className={`
            tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-rounded-md
            ${
              activeTab === "body"
                ? "tw-bg-white tw-text-gray-900"
                : "tw-text-gray-500 hover:tw-text-gray-700"
            }
          `}
        >
          <Video className="tw-w-4 tw-h-4" />
          Body
        </button>
      </div>
    </div>
  );
}
